<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/radANR/tc-custom/9781620060155.jpg?1703851147058" alt="This image is the cover for the book Why Aren't You Sweet Like Me??"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Why Aren't You Sweet Like Me??
      </h1>
      <p class="bookDescription body article font2">
        <b>A pair of newlyweds are separated by war in this emotional, evocative novel inspired by a true WWII love story.</b><br/>  <br/> Camille “Honey” Shaughnessy and Don Shepard fall in love and marry on the eve of World War II. As America enters the war, and Don is pressured into the service by his father, the two newlyweds struggle to maintain contact. Thousands of miles away, Don becomes a hero, saving the lives of his comrades—but, Honey worries, will he make it back to her alive?<br/>  <br/> Moving and memorable, <i>Why Aren’t You Sweet Like Me??</i> is a novel based on the actual love letters exchanged between the author’s grandparents.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Carrie Nyman
      </h2>
      
      <p class="authorDescription body article">My first novel was published in 2012 and, currently, I am a ghostwriter with Mark Graham Communications. You can find me on Twitter @carrienyman. Please visit my website carrienyman.com and tumblr (carrienyman) for more details on my work. Thank you so much for your interest.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Sunbury Press, Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?aeb0ae9e